export const LATIN_AMERICAN_SPANISH_LOCALE = 'es-419';

const LATIN_AMERICAN_SPANISH_REGIONS = [
  '419',
  'ar',
  'bo',
  'br',
  'bz',
  'cl',
  'co',
  'cr',
  'cu',
  'do',
  'ec',
  'gt',
  'hn',
  'jp',
  'mx',
  'ni',
  'pa',
  'pe',
  'pr',
  'py',
  'sv',
  'us',
  'uy',
  've',
];

export const isLatinAmericanSpanish = (locale: string) => {
  const [language, region] = locale.toLowerCase().split(/[-_]/);

  return (
    language === 'es' && LATIN_AMERICAN_SPANISH_REGIONS.includes(region ?? '')
  );
};
